import * as Phaser from "phaser-ce"
import { COLOR } from "../../../common/Color"
import { StudentResultsStore } from "../../../react/students/StudentResultsStore"
import { TransitionState } from "../../GameState"
import { Buttons } from "../../generic-sprites/Buttons"
import { loadGenericAssets } from "../../generic-sprites/GenericAssets"
import { CameraZoom } from "../../utils/CameraZoom"
import { ColorUtils } from "../../utils/ColorUtils"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { Scale } from "../../utils/Scale"
import { Sprites } from "../../utils/Sprites"
import { KidsChoiceAudio, KidsChoiceImages, loadAssets } from "./KidsChoiceAssets"
import { KidsChoiceStore } from "./KidsChoiceStore"
import { KidsChoiceCategoryType, KidsChoiceSpriteType } from "./KidsChoiceTypes"
import { KidsChoiceCategoryContainer } from "./sprites/KidsChoiceCategoryContainer"
import { KidsChoiceSpriteCreator } from "./sprites/KidsChoiceSpriteCreator"
import { KidsChoiceTheater } from "./sprites/KidsChoiceTheater"
import { KidsChoiceVideoSelectContainer } from "./sprites/KidsChoiceVideoSelectContainer"

export class KidsChoicePartOneState extends Phaser.State implements KidsChoiceSharedState {

    static IS_PART_ONE = true
    private currentCategory: KidsChoiceVideoSelectContainer

    sprites: KidsChoiceSpriteCreator
    backgroundGroup: Phaser.Group

    static get centerRectangle(): Phaser.Rectangle {
        return new Phaser.Rectangle(Scale.x(0.1), Scale.y(-0.02), Scale.x(0.8), Scale.y(0.67))
    }

    async preload() {
        loadGenericAssets(this.game)
        loadAssets(this.game)
    }

    async create() {
        await setupKidsChoiceShared(this, true)
    }

    displayOptions = () => {
        const audio = KidsChoiceStore.instance.watchedHealth
            ? this.game.add.audio(KidsChoiceAudio.NEXT_CATEGORY)
            : this.game.add.audio(KidsChoiceAudio.TWO_CATEGORIES)
        const categories = this.sprites.create(KidsChoiceSpriteType.CATEGORY_SELECT, {group: this.backgroundGroup}) as KidsChoiceCategoryContainer
        categories.addOnClick(KidsChoiceCategoryType.HEALTH_EFFECTS, () => this.startCategory(KidsChoiceCategoryType.HEALTH_EFFECTS, this.returnToTheater))
        categories.addOnClick(KidsChoiceCategoryType.SECONDHAND_SMOKE, () => this.startCategory(KidsChoiceCategoryType.SECONDHAND_SMOKE, this.finalAudio))
        audio.onPlay.add(categories.disable)
        audio.onStop.add(() => {
            categories.enable(KidsChoiceStore.instance.watchedHealth ? KidsChoiceCategoryType.SECONDHAND_SMOKE : KidsChoiceCategoryType.HEALTH_EFFECTS)
        })
        audio.play()
    }

    startCategory = (type: KidsChoiceCategoryType, onEnd: () => void) => {
        this.sprites.destroyAll()
        this.createVideoSelectionScreen(type, onEnd)
    }

    returnToTheater = () => {
        this.sprites.destroyAll()
        this.displayOptions()
    }

    finalAudio = () => {
        const audio = this.game.add.audio(KidsChoiceAudio.CAST_VOTE)
        audio.onPlay.add(() => {
            this.currentCategory.submitVote.destroy()
            this.currentCategory.selections.forEach(selection => {
                selection.voteButton.disable()
                selection.disable()
            })

        })
        audio.onStop.add(() => {
            Buttons.create(this.game, "Next", () => {
                    StudentResultsStore.instance.saveKidsChoiceChoice({
                        healthChoice: KidsChoiceStore.instance.votedHealth,
                        secondHandChoice: KidsChoiceStore.instance.votedSecondhand
                    })
                    CameraZoom.resetZoom(this.game)
                    this.game.state.start(TransitionState.KIDS_CHOICE_EXIT)
                },
                {centerInWorldX: true, y: Scale.y(0.69)}
            )
        })
        audio.play()
    }

    private createVideoSelectionScreen = (type: KidsChoiceCategoryType, onEnd: () => void): KidsChoiceVideoSelectContainer =>
        this.currentCategory = this.sprites.create(KidsChoiceSpriteType.VIDEO_SELECT, {
            type,
            onEnd,
            group: this.backgroundGroup
        }) as KidsChoiceVideoSelectContainer
}

export interface KidsChoiceSharedState {
    game: Phaser.Game
    sprites: KidsChoiceSpriteCreator
    backgroundGroup: Phaser.Group
    displayOptions: () => void
}

export const setupKidsChoiceShared = async (sharedState: KidsChoiceSharedState, isPartOne: boolean) => {
    KidsChoicePartOneState.IS_PART_ONE = isPartOne

    KidsChoiceStore.newInstance()
    await PhaserUtils.sharedCreateFunctions(sharedState.game)
    ColorUtils.setBackgroundColor(sharedState.game, COLOR.black)
    sharedState.sprites = new KidsChoiceSpriteCreator(sharedState.game)
    sharedState.backgroundGroup = sharedState.game.add.group()
    const theaterGroup = sharedState.game.add.group()
    Sprites.add(sharedState.game, KidsChoiceImages.STAGE, {group: sharedState.backgroundGroup, y: Scale.y(0.088)})
    const theater = new KidsChoiceTheater(sharedState.game, isPartOne, sharedState.displayOptions, theaterGroup)
    theater.startIntroSequence()
}
